import * as React from "react";

var DetailTable = function DetailTable(props) {
  var poliza = props.poliza;
  return /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Compa\xF1\xEDa:"), /*#__PURE__*/React.createElement("td", null, poliza.company ? poliza.company.name : "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Ramo:"), /*#__PURE__*/React.createElement("td", null, poliza.ramo || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Inicio vigencia:"), /*#__PURE__*/React.createElement("td", null, poliza.start_date || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Fin vigencia:"), /*#__PURE__*/React.createElement("td", null, poliza.finish_date || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Fecha de emisi\xF3n:"), /*#__PURE__*/React.createElement("td", null, poliza.emission_date || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "CMF:"), /*#__PURE__*/React.createElement("td", null, poliza.general_condition_code || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Renovaci\xF3n ?:"), /*#__PURE__*/React.createElement("td", null, poliza.renewal ? "SI" : "NO"), poliza.renewal && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "N\xBA Poliza anterior:"), /*#__PURE__*/React.createElement("td", null, poliza.old_poliza_code || "-"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Archivo P\xF3liza:"), /*#__PURE__*/React.createElement("td", null, poliza.document && poliza.document.document && /*#__PURE__*/React.createElement("a", {
    href: poliza.document.document.url,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }, "Archivo P\xF3liza"))), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Tarjeta de Asistencia:"), /*#__PURE__*/React.createElement("td", null, poliza.assist_card && /*#__PURE__*/React.createElement("a", {
    href: poliza.assist_card,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "glyphicon glyphicon-file"
  }, "Tarjeta")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Archivos Adicionales:"), /*#__PURE__*/React.createElement("td", null, poliza.additional_files && poliza.additional_files.map(function (additionalFile, index) {
    return /*#__PURE__*/React.createElement("a", {
      href: additionalFile.file.url,
      target: "_blank",
      className: "document-link",
      key: index,
      style: {
        marginRight: '15px',
        display: 'inline-block'
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-paperclip text-warning",
      style: {
        marginRight: '5px',
        fontSize: '1.1em'
      }
    }), /*#__PURE__*/React.createElement("span", null, "Archivo ", index + 1));
  }))));
};

export default DetailTable;